
import { mapMutations, mapGetters, mapActions } from 'vuex';
import vClickOutside from 'v-click-outside';

import MenuItems from '@/components/MenuItems';
import HeaderMobileEcom from '~/components/header/HeaderMobileEcom';
import ProfileFilledIcon from '@/components/svg/ProfileFilledIcon.vue';
import ProfileEmptyIcon from '@/components/svg/ProfileEmptyIcon.vue';

import header from '~/mixins/header';

export default {
    mixins: [header],
    components: {
        MenuItems,
        HeaderMobileEcom,
        ProfileFilledIcon,
        ProfileEmptyIcon
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    data() {
        return {
            onScrollIs: false,
            fixedIs: false,
            scrollPos: 100
        };
    },
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings',
            isVitrina: 'global/isVitrina',
            isNovaPorta: 'global/getIsNovaPorta',
            getCurrentTheme: 'global/getCurrentTheme',
            getHeaderStyle: 'global/getHeaderStyle',
            cartProductsLength: 'cart/getProductsLength'
        })
    },
    mounted() {
        if (process.browser) {
            window.addEventListener('scroll', this.handleScroll);
        }
    },
    
    destroyed() {
        if (process.browser) {
            window.removeEventListener('scroll', this.handleScroll);
        }
    },
    methods: {
        ...mapMutations({
            setIsCabinetWindowOpen: 'user/SET_IS_CABINET_WINDOW_OPEN'
        }),
        ...mapActions({
            openCart: 'cart/openCart'
        }),
        handleScroll() {
            this.fixedIs = false;
            if (window.scrollY > 100) {
                this.onScrollIs = true;

                if (this.getHeaderStyle !== 'sticky') {
                    if (window.scrollY < this.scrollPos) {
                        this.fixedIs = true;
                    }
                    this.scrollPos = window.scrollY;
                }
            } else {
                this.onScrollIs = false;
            }
        },
        openCartDynamic() {
            if (this.isVitrina) {
                this.$router.push(this.localePath('/cart'));
            } else {
                this.openCart();
            }
        },
        redirectTo(path) {
            this.setIsCabinetWindowOpen(false);
            this.$router.push(this.localePath(path));
        }
    }
};
